import { useEffect, useState } from 'react';
import { Outlet, useNavigate } from 'react-router-dom';
import { SidebarProvider } from './components/SidebarNew/ui/sidebar';
import { AppSidebar } from './components/SidebarNew/AppSidebar';
import { DashboardHeader } from './components/Header/DashboardHeader';
import styles from './Layout.module.scss';
import useAuthStore from './store/authStore';

interface LayoutProps {
  className?: string;
  contentClassName?: string;
  children?: React.ReactNode;
}

const readHeaderUser = () => {
  const storedUser = JSON.parse(localStorage.getItem('user') || '{}');
  return {
    email: storedUser.email || storedUser.info?.email || '',
    fullname: storedUser.fullname || storedUser.name || storedUser.first_name || storedUser.info?.fullname || '',
    avatar_url: storedUser.avatar || storedUser.avatar_url || storedUser.info?.avatar || '',
    roleName: storedUser.role?.name || storedUser.info?.role?.name || '',
  };
};

export default function DashboardLayout({ className, contentClassName, children }: LayoutProps) {
  const navigate = useNavigate();
  const { clear } = useAuthStore();
  const [user, setUser] = useState(readHeaderUser);

  // Cập nhật header khi thông tin user thay đổi (vd: đổi avatar ở trang cá nhân)
  useEffect(() => {
    const refresh = () => setUser(readHeaderUser());
    window.addEventListener('user-updated', refresh);
    window.addEventListener('storage', refresh);
    return () => {
      window.removeEventListener('user-updated', refresh);
      window.removeEventListener('storage', refresh);
    };
  }, []);

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    clear();
    navigate('/login');
  };

  const handleProfileClick = () => {
    navigate('/admin/profile');
  };

  const [isOpen, setIsOpen] = useState(true);

  useEffect(() => {
    // Sau 3 giây tự động chuyển thành false (thu gọn)
    const timer = setTimeout(() => {
      setIsOpen(false);
    }, 5000);

    return () => clearTimeout(timer);
  }, []);

  return (
    <SidebarProvider open={isOpen} onOpenChange={setIsOpen}>
      <div className={styles.dashboardLayout}>
        {/* Sidebar */}
        <AppSidebar />

        {/* Header Area */}
        <div className={styles.mainContent}>
          <DashboardHeader
            user={user}
            onLogout={handleLogout}
            onProfileClick={handleProfileClick}
          />

          {/* Page Content */}
          <main className={`${styles.content} layout-content-wrapper`}>
            {children}
          </main>
        </div>
      </div>
    </SidebarProvider>
  );
}
